module.exports = __webpack_public_path__ + "static/media/nerdify-icon.0d41f890.svg";